import { IMask } from 'react-imask';

import { maskValidate } from 'features/phone-number/constants';

export const maskPhoneNumber = IMask.createPipe({
  mask: maskValidate,
});
